import React, { useEffect, useState } from "react";

import styles from "./tutorial.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery } from "../utils/GeneralUtils";
import { useNavigate } from "react-router-dom";
import TutorialSelena from "../assets/img/tutorial-selena.webp";
import TutorialPortfolioFront from "../assets/img/tutorial-portfolio-front.webp";
import TutorialPortfolio from "../assets/img/tutorial-portfolio.webp";
import TutorialProject from "../assets/img/tutorial-project.webp";
import TutorialTeam from "../assets/img/tutorial-team.webp";
import TutorialPortfolioFrontPc from "../assets/img/tutorial-portfolio-front-pc.webp";
import TutorialPortfolioPc from "../assets/img/tutorial-portfolio-pc.webp";
import TutorialProjectPc from "../assets/img/tutorial-project-pc.webp";
import TutorialTeamPc from "../assets/img/tutorial-team-pc.webp";
import SonicLink from "./routing/SonicLink";

const TutorialModal: React.FC = () => {
  const [page, setPage] = useState<number>(0);
  const [isComplete, setIsComplete] = useState<boolean>(false);

  const query = useQuery();
  const navigate = useNavigate();

  const handlePage = (page: number): void => {
    if (0 < page || page < 5) {
      setPage(page);
    }
  };

  const handleClose = (): void => {
    query.delete("showTutorial");
    navigate({ search: query.toString() });
    setIsComplete(true);

    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = "unset";
    }
  };

  const genMessage = () => {
    switch (page) {
      default:
      case 0:
        return (
          <p className={styles["tutorial_message_text"]}>
            SELeCTへようこそ。
            <br />
            ワタシはセレナ。
            <br />
            SELeCTのナビゲーターです。
            <br />
            これからSELeCTに登録してからできることを確認していきましょう!!
          </p>
        );
      case 1:
        return (
          <p className={styles["tutorial_message_text"]}>
            まずは<span>プロジェクト機能。</span>
            <br />
            SELeCTに掲載されている<span>様々な募集に応募</span>
            することができます。eスポーツ活動のチャンスを掴みましょう!!
          </p>
        );
      case 2:
        return (
          <p className={styles["tutorial_message_text"]}>
            プロジェクト応募の
            <span>成功率アップに役立つのがプロフィール</span>機能。
            <br />
            自身やグループメンバーの情報をSELeCTに掲載してアピールしましょう。
            <span>他の会員からオファーが来る</span>ようにもなります。
          </p>
        );
      case 3:
        return (
          <p className={styles["tutorial_message_text"]}>
            チームの情報をSELeCTに登録したい方は
            <span>マイページからチーム登録</span>
            をしましょう！チームを登録後、プロフィール設定のチーム選択することで、
            <span>プロフィールにチームが表示</span>されます。
          </p>
        );
      case 4:
        return (
          <p className={styles["tutorial_message_text"]}>
            プロフィールは<span>ひとつのアカウント内で複数登録</span>
            することが可能です。
            <br />
            チームメンバーをまとめて管理したい方や、複数の活動名義をお持ちの方はぜひご利用ください。
          </p>
        );
      case 5:
        return (
          <p className={styles["tutorial_message_text"]}>
            今回説明した内容、その他機能の詳細は
            <SonicLink to="/info/guide">ご利用ガイド</SonicLink>
            をチェックしてください。それではSELeCTで良いeスポーツ活動を!!
          </p>
        );
    }
  };

  const genTutorialImage = () => {
    switch (page) {
      default:
      case 0:
        return TutorialSelena;
      case 1:
        return TutorialProject;
      case 2:
        return TutorialPortfolioFront;
      case 3:
        return TutorialTeam;
      case 4:
        return TutorialPortfolio;
      case 5:
        return TutorialSelena;
    }
  };

  const genTutorialImagePc = () => {
    switch (page) {
      default:
      case 0:
        return TutorialSelena;
      case 1:
        return TutorialProjectPc;
      case 2:
        return TutorialPortfolioFrontPc;
      case 3:
        return TutorialTeamPc;
      case 4:
        return TutorialPortfolioPc;
      case 5:
        return TutorialSelena;
    }
  };

  useEffect(() => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = "hidden";

      return () => {
        html.style.overflowY = "unset";
      };
    }
  }, []);

  return (
    <>
      {!isComplete ? (
        <div className={styles["tutorial"]}>
          <div className={styles["tutorial-content"]}>
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet={genTutorialImagePc()}
              />
              <img
                src={genTutorialImage()}
                className={styles["tutorial_img"]}
              />
            </picture>
            <div
              className={
                page == 0 || page == 5
                  ? styles["tutorial_message--balloon"]
                  : styles["tutorial_message"]
              }
            >
              {genMessage()}
            </div>
            {/* <div className={styles["tutorial__pagecount"]}>
              {() => {
                for (let i = 0; i < 5; i++) {
                  return (
                    <button
                      onClick={() => handlePage(i)}
                      className={
                        page == i ? styles["currentpage"] : styles["pageicon"]
                      }
                    />
                  );
                }
              }}
            </div> */}
            <div className={styles["tutorial__button-box"]}>
              {page !== 5 ? (
                <button
                  onClick={() => handlePage(page + 1)}
                  className={styles["nextbutton"]}
                >
                  {page == 0 ? "よろしくお願いします " : "次へ "}
                  <FontAwesomeIcon icon={["fas", "chevron-right"]} />
                </button>
              ) : null}

              {page !== 0 ? (
                <button
                  onClick={() => handlePage(page - 1)}
                  className={`
                  ${styles["backbutton"]}
                  ${page == 5 ? styles["backbutton--last"] : ""}
                `}
                >
                  <FontAwesomeIcon icon={["fas", "chevron-left"]} /> 戻る
                </button>
              ) : null}
              <button
                onClick={() => handleClose()}
                className={styles["closebutton"]}
              >
                不要なので閉じる <FontAwesomeIcon icon={["fas", "times"]} />
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default TutorialModal;
